import React, { useContext } from "react";
import BreadcrumbContainer from "../../app/common/breadcrumb/BreadcrumbContainer";
import { Segment, Accordion, Icon } from "semantic-ui-react";
import ListTrackDocuments from "./ListTrackDocuments";
import FilterForm from "./FilterForm";
import { sectionHome } from "../../app/util/breadcrumbOptions";
import FilterFormInfo from "./FilterFormInfo";
import { RootStoreContext } from "../../app/stores/rootStore";
import { observer } from "mobx-react-lite";

const DashboardTrackingDocuments: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    changeAcordionFilterState,
    acordionFilterState,
  } = rootStore.trackDocumentStore;

  const match = {
    url: '/home/TrackingDocuments',
  };

  document.title = "Seguimiento documentos electrónicos";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Seguimiento documentos electrónicos"
        sections={sectionHome}
      />
      <Segment className="accordionSegment">
        <Accordion>
          <Accordion.Title
            active={acordionFilterState}
            onClick={() => changeAcordionFilterState()}
          >
            <Icon name="dropdown" />
            {acordionFilterState ? "Ocultar filtros" : "Ver filtros"}
          </Accordion.Title>
          <Accordion.Content active={acordionFilterState}>
            <FilterForm />
          </Accordion.Content>
          <Accordion.Content active={!acordionFilterState}>
            <FilterFormInfo />
          </Accordion.Content>
        </Accordion>

        <ListTrackDocuments match={`${match.url}`} />
        <br />
      </Segment>
    </div>
  );
};

export default observer(DashboardTrackingDocuments);
